<template>
  <div class="info" v-if="activePickupBox.id" data-testid="infoId">
    <p>{{ $t('id') }}</p>
    <span>{{ activePickupBox.id }}</span>
  </div>
  <div v-for="(item, index) in infoPickupBox" :key="index">
    <div
      class="info"
      v-if="
        activePickupBox.info[item.value] || activePickupBox.info[item.value2]
      "
      :data-testid="item.dataTestid"
    >
      <p>{{ item.label }}</p>
      <span>
        {{
          getValue(
            item.dataTestid,
            activePickupBox.info[item.value],
            activePickupBox.info[item.value2]
          )
        }}
      </span>
    </div>
  </div>
  <div class="info infoDelivery">
    <div class="infoDelivery-item">
      <div class="title">{{ $t('basicLocker') }}</div>
      <div class="content">
        <div v-for="(item, index) in infoDeliveryRulesBasicLocker" :key="index">
          <div
            class="content-info"
            v-if="activePickupBox.info.deliveryRulesBasicLocker[item.value]"
            :data-testid="item.dataTestid"
          >
            <p>{{ item.label }}</p>
            <span>
              {{
                msToDays(
                  activePickupBox.info.deliveryRulesBasicLocker[item.value]
                )
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="infoDelivery-item">
      <div class="title">{{ $t('fridgeLocker') }}</div>
      <div class="content">
        <div
          v-for="(item, index) in infoDeliveryRulesFridgeLocker"
          :key="index"
        >
          <div
            class="content-info"
            v-if="activePickupBox.info.deliveryRulesFridgeLocker[item.value]"
            :data-testid="item.dataTestid"
          >
            <p>{{ item.label }}</p>
            <span>
              {{
                msToDays(
                  activePickupBox.info.deliveryRulesFridgeLocker[item.value]
                )
              }}
            </span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div v-for="(item, index) in infoIntervalTime" :key="index">
    <div
      class="info"
      v-if="activePickupBox.info[item.value]"
      :data-testid="item.dataTestid"
    >
      <p>{{ item.label }}</p>
      <span>
        {{ msToMin(activePickupBox.info[item.value]) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

import { langsEn, langsFi, langsSv, langsNo } from '@/services/languageService';

import {
  infoPickupBox,
  infoIntervalTime,
  infoDeliveryRulesBasicLocker,
  infoDeliveryRulesFridgeLocker
} from './configs';

@Options({
  name: 'InfoActiveBox',
  props: ['activePickupBox'],
  data() {
    return {
      langsEn,
      langsFi,
      langsSv,
      langsNo,
      infoPickupBox: infoPickupBox(this.$t),
      infoIntervalTime: infoIntervalTime(this.$t),
      infoDeliveryRulesBasicLocker: infoDeliveryRulesBasicLocker(this.$t),
      infoDeliveryRulesFridgeLocker: infoDeliveryRulesFridgeLocker(this.$t)
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    getValue(dataTestid: string, value: string, value2: string) {
      switch (dataTestid) {
        case 'infoAddress':
          return `${value} ${value2}`;
        case 'infoLanguages':
          return this.getLang(value);
        case 'infoVersionSW':
          return value;
      }
    },
    msToDays(ms: number) {
      return ms <= 1 ? ms + this.$t('day') : ms + this.$t('days');
    },
    msToMin(ms: number) {
      const min = ms / 60000;

      return min === 1 ? min + this.$t('minute') : min + this.$t('minutes');
    },
    getLang(uiLanguages: Array<string>) {
      if (this.user) {
        switch (this.user?.appLanguage) {
          case 'en':
            return uiLanguages.map((i: string) => langsEn[i]).join(', ');
          case 'fi':
            return uiLanguages.map((i: string) => langsFi[i]).join(', ');
          case 'sv':
            return uiLanguages.map((i: string) => langsSv[i]).join(', ');
          case 'no':
            return uiLanguages.map((i: string) => langsNo[i]).join(', ');
        }
      }
    }
  }
})
export default class InfoActiveBox extends Vue {}
</script>

<style lang="scss" scoped>
.info {
  margin-top: 32px;
  margin-bottom: 32px;
  background-color: $light-grey;
  &:first-child {
    margin-top: 14px;
  }
  p {
    font-size: $twelveSize;
    color: $label;
    background-color: $light-grey;
  }
  span {
    font-size: $fourteenSize;
    color: $mid-grey;
    background-color: $light-grey;
  }
  &.infoDelivery {
    display: flex;
    column-gap: 25px;
    .infoDelivery-item {
      background-color: $light-grey;
      .title {
        font-size: $fourteenSize;
        background-color: $light-grey;
      }
      .content {
        background-color: $light-grey;
        .content-info {
          margin-top: 12px;
          background-color: $light-grey;
        }
      }
    }
  }
}
</style>
